import { useQuery } from 'react-query';
import { Axios as api } from '@helpers';
import { EvidenceSocialMedia } from '@services/types/api';
export const getEvidenceImages = async ({
  modelId,
  id,
}: {
  modelId: string;
  id: string;
}): Promise<EvidenceSocialMedia[]> => {
  const response = await api.get(`/admin/models/${modelId}/social-media-links/${id}/evidence`);
  return response.data;
};

const useGetEvidenceImages = (id: string, modelId: string) => {
  return useQuery(['get-evidence-images', modelId, id], () => getEvidenceImages({ modelId, id }), {
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};
export default useGetEvidenceImages;
